var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "responsible" }, [
    _vm.worker
      ? _c(
          "div",
          { staticClass: "wrapper" },
          [
            _c("userpic", {
              staticClass: "icon",
              attrs: { url: _vm.worker.photo },
            }),
            _c(
              "div",
              { staticClass: "data" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "name",
                    attrs: {
                      target: "_blank",
                      to: {
                        name: "personal-employee-summary",
                        params: { id: _vm.worker.id },
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.worker.name) + " ")]
                ),
                _c("div", { staticClass: "label" }, [_vm._v("Ответственный")]),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "34",
                  height: "34",
                  viewBox: "0 0 34 34",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("circle", {
                  attrs: { cx: "17", cy: "17", r: "17", fill: "#BFC9E0" },
                }),
                _c("path", {
                  attrs: {
                    d: "M12 14C12 13.0111 12.2932 12.0444 12.8427 11.2222C13.3921 10.3999 14.173 9.75904 15.0866 9.3806C16.0002 9.00217 17.0055 8.90315 17.9755 9.09608C18.9454 9.289 19.8363 9.76521 20.5355 10.4645C21.2348 11.1637 21.711 12.0546 21.9039 13.0246C22.0969 13.9945 21.9978 14.9998 21.6194 15.9134C21.241 16.8271 20.6001 17.6079 19.7779 18.1574C19.4501 18.3763 19.007 18.5103 18.7335 18.6899C17.5 19.5 17 20 17 22",
                    stroke: "white",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "17", cy: "26", r: "1", fill: "white" },
                }),
              ]
            ),
          ]),
          _c("div", { staticClass: "data" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Ответственного нет")]),
            _c(
              "div",
              {
                staticClass: "assign",
                on: {
                  click: function ($event) {
                    return _vm.$emit("assign")
                  },
                },
              },
              [_vm._v("Назначить")]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }